import * as React from 'react';
export const rbscitizensSvg = React.forwardRef(function rbscitizensSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#00A777',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M24.35 16.34h-3.19c-.68 0-1.3.4-1.5 1-.58 1.7-2.24 2.3-2.24 2.3-.6.22-1.06.8-1.06 1.5v3.2c0 .88.73 1.59 1.61 1.59.88 0 1.58-.66 1.58-1.59l-.03-2.56 3.7 3.7c.62.62 1.62.62 2.25 0 .63-.63.63-1.67 0-2.3l-3.64-3.62h2.5c.89 0 1.62-.73 1.62-1.6 0-.89-.73-1.62-1.61-1.62h.01zm-.03-3.87-2.57.02 3.7-3.7a1.6 1.6 0 0 0 0-2.26 1.59 1.59 0 0 0-2.26 0l-3.65 3.65V7.66c0-.95-.72-1.6-1.6-1.6-.88 0-1.61.72-1.61 1.6v3.2c0 .68.43 1.3 1.03 1.5 1.68.59 2.26 2.24 2.26 2.24.23.6.83 1.06 1.5 1.06h3.2c.88 0 1.6-.73 1.6-1.61 0-.87-.65-1.58-1.6-1.58zm-10.28-6.4c-.88 0-1.58.59-1.56 1.6l.04 2.56-3.7-3.7a1.59 1.59 0 0 0-2.25 0 1.6 1.6 0 0 0 0 2.27l3.61 3.64H7.7c-.9 0-1.61.73-1.61 1.61 0 .88.7 1.61 1.6 1.61h3.2c.68 0 1.28-.4 1.5-1 .58-1.71 2.22-2.3 2.22-2.3.62-.22 1.05-.8 1.05-1.5v-3.2c0-.88-.7-1.58-1.6-1.58h-.02zm.58 13.54c-1.68-.6-2.26-2.24-2.26-2.24a1.64 1.64 0 0 0-1.5-1.05h-3.2c-.88 0-1.6.73-1.6 1.6 0 .89.6 1.6 1.6 1.6l2.56-.03-3.69 3.7a1.6 1.6 0 0 0 0 2.26c.63.63 1.63.63 2.26 0l3.64-3.65v2.52a1.6 1.6 0 0 0 3.19 0v-3.2c0-.68-.4-1.3-1-1.5z',
      }),
    ),
  );
});
rbscitizensSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var rbscitizens = {
  category: 'brand',
  colorable: false,
  name: 'rbscitizens',
  svg: rbscitizensSvg,
};
